import React, { Fragment } from 'react';
import s from './style.module.sass';
import { connect } from 'react-redux';
import moment from 'moment';
import { updateTimeslot } from '../../actions/page2-actions';
import { updateDate } from '../../actions/page2-actions';
import { updateActiveTimeslot } from '../../actions/page2-actions';
import { updateNextButton } from '../../actions/global-actions';

class Timeslots extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			'activeTimeslot': [null, null]
		}
	}

	handleTimeslotClick(timeslot, dayindex, timeslotindex) {
		this.props.updateNextButton(true)
		this.props.updateDate(moment(timeslot.start).format('YYYY-MM-DD'));
		this.props.updateTimeslot(timeslot);
		this.props.updateActiveTimeslot([dayindex, timeslotindex])

		this.setState({
			'activeTimeslot': [dayindex, timeslotindex],
		})
	
	}

	render() {
		return (
			<Fragment>{
				Object.values(this.props.timeslots).map((timeslots, dayindex) =>
					<div className={`${s.dayTimeslots} ${timeslots.length > 0 && moment(this.props.date).local().isSame(moment(timeslots[0].start).local(), 'day') ? s.mActiveDay : ''}`} key={dayindex}>
						{timeslots.map((timeslot, timeslotindex) =>
							<button
								key={timeslotindex}
								onClick={() => this.handleTimeslotClick(timeslot, dayindex, timeslotindex)}
								className={`
									${s.timeslot} 
									${timeslot.available === true ? "" : s.mDisabled} 
									${dayindex === this.props.activeTimeslot[0] && timeslotindex === this.props.activeTimeslot[1] ? s.activeTimeslot : ''}
								`}>
								{
									moment(timeslot.start).local().format('HH:mm')
								}
							</button>
						)}
					</div>
				)
			}</Fragment>
		)
	}
}

export default connect(
	state => state.page2, 
	{ updateTimeslot, updateActiveTimeslot, updateDate, updateNextButton}
)(Timeslots); 